/* =====================================================
   Collection List — JavaScript del carrusel
   Archivo: assets/section-collection-list.js
   ===================================================== */
 
class CollectionListCarousel extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.track = this.querySelector('.collection-list-section__track');
    this.prevBtn = this.querySelector('.collection-list-section__nav-btn--prev');
    this.nextBtn = this.querySelector('.collection-list-section__nav-btn--next');
  }
 
  connectedCallback() {
    if (!this.track) return;
    this.initCarousel();
    this.updateButtons();
    this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
  }
 
  initCarousel() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.scroll('prev'));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.scroll('next'));
    }
  }
 
  scroll(direction) {
    const items = this.track.querySelectorAll('.collection-list-section__item');
    if (!items.length) return;
    const itemWidth = items[0].offsetWidth + parseInt(getComputedStyle(this.track).gap || 12);
    const visibleCount = Math.floor(this.track.offsetWidth / itemWidth);
    const scrollAmount = itemWidth * Math.max(1, visibleCount - 1);
 
    this.track.scrollBy({
      left: direction === 'next' ? scrollAmount : -scrollAmount,
      behavior: 'smooth'
    });
  }
 
  updateButtons() {
    if (!this.prevBtn || !this.nextBtn) return;
    const { scrollLeft, scrollWidth, offsetWidth } = this.track;
    this.prevBtn.disabled = scrollLeft <= 0;
    this.nextBtn.disabled = scrollLeft + offsetWidth >= scrollWidth - 1;
  }
}
 
if (!customElements.get('collection-list-section')) {
  customElements.define('collection-list-section', CollectionListCarousel);
}